module.exports = "/_next/static/images/avatar-mask-red-6c27254f.png";